import ErrorIcon from "@mui/icons-material/Error";
import { Box, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import {
  FeatureState,
  PTOPFeatureListDto,
  useProjectApi,
} from "~/api/GeneratedApi";
import GenericTable, {
  CustomColumn,
  CustomTableProps,
} from "~/components/GenericTable";
import { LinearProgressWithLabel } from "~/components/LinearProgressWithLabel";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";
import { useProjectDetails } from "./hooks/useProjectDetails";

export const ProjectSubareaContent = () => {
  const { t } = useTranslation("projects");
  const { id } = useProjectDetails();
  const { getFeatures } = useProjectApi();
  const columns = React.useMemo(
    (): CustomColumn<PTOPFeatureListDto>[] => [
      {
        field: "area",
        title: t("area"),
        width: "auto",
      },
      {
        field: "subArea",
        title: t("subarea"),
        width: "auto",
      },
      {
        field: "vessel",
        title: t("vessel"),
        width: "auto",
      },
      {
        field: "status",
        title: t("status"),
        width: "auto",
      },
      {
        field: "progress",
        title: t("projects:progress"),
        render: ({ progress }) => <LinearProgressWithLabel value={progress} />,
      },
      {
        field: "state",
        title: t("valid"),
        width: "auto",

        render: ({ state }) =>
          state !== FeatureState.Valid && (
            <Tooltip
              title={
                (state === FeatureState.MissingFromProject
                  ? t("projects:errorTextProjectTop")
                  : t("projects:errorTextGeometry")) ?? ""
              }
            >
              <ErrorIcon color="error" />
            </Tooltip>
          ),
      },
    ],
    [t],
  );

  const tableProps = React.useMemo(
    (): CustomTableProps<PTOPFeatureListDto> => ({
      title: t("general:sub-areas"),
      options: {
        filtering: false,
        pageSize: 10,
        idSynonym: "subArea",
        paging: false,
        search: false,
      },
    }),
    [t],
  );

  const { data } = useCustomQuery({ key: "project-subareas", id }, () =>
    getFeatures(id),
  );

  //   const getFilteredFeatures = () => {
  //     return async (options: QueryOptions) => {
  //       return {
  //         results: await getFeatures(projectId, options),
  //         pageSize: 0,
  //         currentPage: 0,
  //         totalCount: 0,
  //       };
  //     };
  //   };

  return (
    <Box
      sx={{
        "& div": {
          boxShadow: "none",
        },
      }}
    >
      <GenericTable<PTOPFeatureListDto>
        // fetch={getFilteredFeatures()}
        data={data ?? []}
        columns={columns}
        tableProps={tableProps}
      />
    </Box>
  );
};
